import Flickity from "flickity";
import "flickity/dist/flickity.min.css";

export default (ref) => ({
    ref: ref,
    carousel: undefined,
    active: 0,

    init() {
        this.$nextTick(() => {
            this.carousel = new Flickity(this.$refs[this.ref], {
                wrapAround: true,
            });

            this.carousel.on('change', () => {
                this.active = this.carousel.selectedElement.attributes.id.value;
            });
        });
    },
});
